import { ShieldAlert, ShieldCheck } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import type { ImageTriageDto } from "../../types";
import { ENFORCEMENT_COPY, OBSERVE_ONLY_COPY } from "./imageTriageCopy";

export function ImageTriageModeBadge({ dto }: { dto: ImageTriageDto }) {
  const observeOnly = dto.observe_only;
  const label = observeOnly ? "Observe only" : "Strict duplicate enforcement";
  const description = observeOnly ? OBSERVE_ONLY_COPY : ENFORCEMENT_COPY;
  const Icon = observeOnly ? ShieldCheck : ShieldAlert;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label={`${label}: ${description}`}
        >
          <Badge variant={observeOnly ? "secondary" : "outline"}>
            <Icon className="size-3" aria-hidden />
            {label}
          </Badge>
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-80">{description}</TooltipContent>
    </Tooltip>
  );
}

export function ImageTriageSuppressionSummary({
  dto,
}: {
  dto: ImageTriageDto;
}) {
  if (dto.observe_only || !dto.suppression) return null;

  const { suppressed_occurrences: withheld, retained_occurrences: retained } =
    dto.suppression;
  return (
    <Alert>
      <ShieldAlert aria-hidden />
      <AlertTitle>Director input</AlertTitle>
      <AlertDescription>
        {withheld} withheld; {retained} passed to director. Only byte-identical
        or canonical-pixel-identical uploads are enforcement inputs.
      </AlertDescription>
    </Alert>
  );
}
